/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Return a list of Z-test alternative hypotheses.
*
* @module @stdlib/stats/base/ztest/alternatives
*
* @example
* import alternatives from '@stdlib/stats/base/ztest/alternatives';
*
* var list = alternatives();
* // e.g., returns [ 'two-sided', 'less', 'greater' ]
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import enumeration from './enum.js';


// MAIN //

setReadOnly( main, 'enum', enumeration );


// EXPORTS //

export default main;
